import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
const uncapitalizeObjectKeys = (capitalizedObject) => {
  if (capitalizedObject === void 0) {
    return void 0;
  }
  return Object.keys(capitalizedObject).reduce((acc, key) => _extends({}, acc, {
    [`${key.charAt(0).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
  }), {});
};
export {
  uncapitalizeObjectKeys
};
//# sourceMappingURL=slotsMigration.es.js.map
